export default "__VITE_ASSET__7aa56486__"